import { Component, OnInit, Input } from "@angular/core";
import { TestimonialConfig } from "../../testimonial-config";

@Component({
    selector: "app-homepage-testimonial",
    templateUrl: "./testimonial.component.html",
    styleUrls: ["./testimonial.component.scss"],
    standalone: false
})
export class HomepageTestimonialComponent implements OnInit {
  @Input() testimonial: TestimonialConfig;

  constructor() {}

  ngOnInit() {}
}
